export default "__VITE_ASSET__4983f616__"